import {using} from './h'

import {Title} from './title'
import {Vizion} from './vizion'
import {GraphView} from './graphView'
import {AppGrid} from './appgrid'
import {TabsHeader} from './tabsHeader'

// import './idb/localStorage'
// import './leakCheck'

using(document.body, () => {
  Title()
  TabsHeader()
  Vizion()
  GraphView()
  AppGrid()
})

try {
  const observer = new PerformanceObserver(list => {
    const perfEntries = list.getEntries()
    for (let i = 0; i < perfEntries.length; i++) {
      const entry = perfEntries[i]
      console.log('long task:', entry.name, entry.duration)
    }
  })
  observer.observe({entryTypes: ['longtask']})
} catch (err) {
  console.log(err.message)
}
